import React, {Component, Fragment} from 'react';
import CloseActionButton from '../common/CloseActionButton';
import MyProfileDetailsForm from './MyProfileDetailsForm';
import {connect} from "react-redux";

class MyProfileEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        employeeIdentifier: 
          this.props.profile.employeeIdentifier
            ? this.props.profile.employeeIdentifier.toString()
            : '',
        email: this.props.profile.email,
        firstName: this.props.profile.firstName,
        gender: this.props.profile.gender,
        lastName: this.props.profile.lastName,
      },
    };
  }


  get isLoading() {
    return this.props.isLoading.includes('updateMyProfile');
  }

  render() {
    return (
      <Fragment>
        <MyProfileDetailsForm
          isLoading={this.isLoading}
          initialValues={this.state.initialValues}
          onSave={formData => this.props.onSave(formData)}
        />
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.myProfile.isLoading,
  };
};

export default connect(mapStateToProps)(MyProfileEdit);
